const LABELS = { form: "Isi laporan", status: "Hari ini", blockers: "Blocker", mine: "Laporan saya", team: "Tim", ranking: "Peringkat", panel: "Panel" };

export default function SectionNav({ order }) {
  const items = order.filter((id) => LABELS[id]);
  return (
    <nav data-testid="section-nav" className="sticky top-0 z-30 -mx-4 border-b border-brand-line bg-white/85 px-4 backdrop-blur-xl sm:mx-0 sm:rounded-b-2xl">
      <div className="no-scrollbar flex gap-1 overflow-x-auto py-2">
        {items.map((id) => (
          <a key={id} href={`#${id}`} data-testid={`nav-${id}`}
            className="inline-flex min-h-[40px] shrink-0 items-center rounded-full px-3.5 text-sm font-semibold text-brand-ink transition-colors hover:bg-brand-tint hover:text-brand-deep">
            {LABELS[id]}
          </a>
        ))}
      </div>
    </nav>
  );
}
